import React, { useEffect, useState, useMemo } from 'react'
import { DateTime } from 'luxon'

/**
 * 
 * 蒙层组件
 * 
 * @param {object or object array} timeRegion 设置时间区间，以及时间区间内的提示内容，不在时间区间内容默认不显示此组件
 *                                            格式：[{ region: [start_time, end_time], message: '' }]
 * @returns 
 */
export default function TimeMaske({ timeRegion, style, ...props }) {
    const [当前时间, 设置当前时间] = useState(DateTime.now())

    const data = useMemo(() => {
        for (let item of timeRegion) {
            if (当前时间 > item.region[0] && 当前时间 < item.region[1]) {
                return item.message
            }
        }

        return null
    }, [timeRegion, 当前时间])

    useEffect(() => {
        const id = setInterval(() => 设置当前时间(DateTime.now()))

        return () => clearInterval(id)
    })

    if (data === null) return data

    return (
        <div
            style={{
                position: 'fixed',
                zIndex: '5',
                top: '0px',
                left: '0px',
                right: '0px',
                bottom: '0px',
                margin: 'auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#fff',
                backgroundColor: 'rgba(0,0,0,.6)',
                ...style
            }}
            {...props}
        >
            {data}
        </div>
    )
}
